import { connect } from 'react-redux';
import ParticipantsSelect from './ParticipantsSelect';
import clubAction from '../../../actions/participant';


export default connect(
  ({ participant: { items, list } }) => ({
    items: list.map(key => items[key])
  }),
  dispatch => ({
    fetch: () => dispatch(clubAction.fetchList())
  })
)(ParticipantsSelect);



// WEBPACK FOOTER //
// ./src/components/Participants/ParticipantsSelect/index.js